import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { selectFormIsReadonly } from "../../services/form/slices";
import { selectIsAdmin } from "../../services/authorization/slices";
const roParam = 'readOnly'
const options = {
  yes: 'yes',
  no: 'no',
}
function useReadOnlyMode() {
  const { type, id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams()
  const isAdmin = useSelector(selectIsAdmin);
  const readOnly = useSelector(
    (state) => {
      return selectFormIsReadonly(state, {
        id,
        type
      })
    }
  );
  const override = isAdmin ? searchParams.get(roParam)?.toLowerCase() : undefined

  const toggleReadOnly = (checked) => {
    searchParams.set(roParam, checked === true ? options.yes : options.no);
    setSearchParams(searchParams)
  }

  return {
    readOnly: override ? override === options.yes : readOnly,
    toggleReadOnly
  };
}

export default useReadOnlyMode;
